export const setExecutiveTeam = '@executiveTeam/setExecutiveTeam';
export const setReload = '@executiveTeam/setReload';
export const setUpdateData = '@executiveTeam/setUpdateData';
export const setAddNewStatus = '@executiveTeam/setAddNewStatus';
export const setCurrentPage = '@executiveTeam/setCurrentPage';
